import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { BuyflowProductOffering } from 'anchor-shared/lib/model/interface/buyflowProductOffering';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { Moment } from 'moment';
import * as moment from 'moment';
import { VesselAvailabilityPreferences } from 'anchor-shared/lib/model/entity/vesselAvailabilityPreferences';
import { VesselDAO } from '../../../../core/services/dao/vesselDAO';
import {
  BuyflowCharterInformation,
  CharterBuyflowHelperService,
  sortTimes,
} from '../../../../core/services/charter-buyflow/charter-buyflow-helper-service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { dateSessionStorageFormat } from '../../../buyflow-home/buyflow-home.component';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { MatDialogRef } from '@angular/material/dialog';
import { selectedProductVesselIdWrapper } from '../../../shared/public-components/request-booking-form/request-booking-form.component';
import { isPlatformBrowser } from '@angular/common';
import { delay } from 'rxjs/operators';
import { CharterType } from 'anchor-shared/lib/model/enum/charter-type';
import { DateRange } from '@angular/material/datepicker';
import { VesselAvailabilityDAO } from '../../../../core/services/dao/VesselAvailabilityDAO';
import { termAvailabilityResponse } from 'anchor-shared/lib/model/interface/termAvailabilityResponse';
import { ProductOfferingDAO } from '../../../../core/services/dao/productOfferingDAO';
import { CharterVesselAvailabilityDAO } from '../../../../core/services/dao/charterVesselAvailabilityDAO';
import { getTermCharterDateCount } from 'anchor-shared/lib/service/pure-functions/charter-pricing/charter-pricing-helper';
import {
  AddOn,
  RequiredAddOnUnitType,
} from 'anchor-shared/lib/model/entity/addOn';

@Component({
  selector: 'app-mobile-booking-availability',
  templateUrl: './mobile-booking-availability.component.html',
  styleUrls: ['./mobile-booking-availability.component.scss'],
  providers: [CharterBuyflowHelperService],
})
export class MobileBookingAvailabilityComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  productsOffered: BuyflowProductOffering[];
  buyflowProductOfferings: BuyflowProductOffering[] = [];
  isDateSelected: boolean;
  availableOn: Moment;
  availableFrom: Moment = null;
  availableTo: Moment = null;
  vessel: Vessel;
  selectedProduct: BuyflowProductOffering;
  startMobileDate: boolean;
  vesselPrefs: VesselAvailabilityPreferences;
  unavailables: any[];
  dateToDisplay: string = 'Date';
  listPrice: string;
  charterType: CharterType;
  termCharterPricing: termAvailabilityResponse;
  requiredAddOns: AddOn[] = [];
  selectedDates;
  displaySelectedDates: string = null;
  termDayCount: number;
  termDateRangeUnavailable: boolean = false;
  CharterType = CharterType;
  loadingTermPricing: boolean;

  productDuration: number;
  productText: string = 'Select a duration';
  startTimeText: string;
  guestCount: number = 1;
  selectableTimes: string[] = [];
  pricingSettled: boolean = false;
  isBrowser: boolean;
  productSelectionChange = new BehaviorSubject<BuyflowProductOffering>(null);
  subs: Subscription[] = [];
  fuelIncludedInCharter: boolean;
  headerPrice: any;

  constructor(
    private dialogRef: MatBottomSheetRef<MobileBookingAvailabilityComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      products: BuyflowProductOffering[];
      isDateSelected: boolean;
      availableOn: Moment;
      vessel: Vessel;
      selectedProduct: BuyflowProductOffering;
      vesselPrefs: VesselAvailabilityPreferences;
      charterType: CharterType;
      termCharterPricing: termAvailabilityResponse;
      availableFrom: Moment;
      availableTo: Moment;
      termDateRangeUnavailable: boolean;
    },
    private vesselAvailabilityDAO: VesselAvailabilityDAO,
    private charterBuyflowHelperService: CharterBuyflowHelperService,
    private productOfferingDAO: ProductOfferingDAO,
    private charterVesselAvailabilityDAO: CharterVesselAvailabilityDAO,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.productsOffered = this.data.products || [];
    this.isDateSelected = this.data.isDateSelected;
    this.availableOn = this.data.availableOn;
    this.availableFrom = this.data.availableFrom;
    this.availableTo = this.data.availableTo;
    this.vessel = this.data.vessel;
    this.selectedProduct = this.data.selectedProduct;
    this.vesselPrefs = this.data.vesselPrefs;
    this.guestCount = this.vessel.numOfPassengers;
    this.fuelIncludedInCharter = this.vessel.fuelIncluded;
    this.charterType = this.data.charterType;
    this.termCharterPricing = this.data.termCharterPricing;
    this.selectedDates = new DateRange(this.availableFrom, this.availableTo);
    this.termDateRangeUnavailable = this.data.termDateRangeUnavailable;

    this.handleRequiredAddOnsQty();
    this.getProductsForDay();
    if (this.termCharterPricing) {
      this.getTermCharterPricing();
    }
    if (
      this.selectedDates.start?.isValid() &&
      this.selectedDates.end?.isValid()
    ) {
      this.displaySelectedDates = `${this.selectedDates.start?.format(
        'MMM DD',
      )} - ${this.selectedDates.end.format('MMM DD')}`;
    }
    this.watchForProductChange();
    const unavailSub = this.vesselAvailabilityDAO
      .getFullUnavailables(this.vessel.id)
      .subscribe((data) => {
        this.unavailables = data;
      });

    if (this.availableOn && this.availableOn.isValid()) {
      this.dateToDisplay = this.availableOn.format('dddd, MMMM Do, YYYY');
      if (this.productsOffered?.length) {
        this.setSelectedProduct();
        this.updateSelectableTimes();
      }
    }

    if (
      !this.productsOffered &&
      this.availableOn &&
      this.availableOn.isValid() &&
      this.charterType === CharterType.DayCharter
    ) {
      this.dateToDisplay = this.availableOn.format('dddd, MMMM Do, YYYY');
    }

    this.subs.push(unavailSub);
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  dateRangeFilter = (incomingMoment: Moment): boolean => {
    if (
      (incomingMoment && incomingMoment.isBefore(moment(), 'day')) ||
      !incomingMoment
    ) {
      return false;
    }

    return !this.vessel.calendarPreferences.some((calPref) => {
      let isAfter = incomingMoment.isSameOrAfter(
        moment(calPref.fromDate),
        'day',
      );
      let isBefore = incomingMoment.isSameOrBefore(
        moment(calPref.toDate),
        'day',
      );
      if (!calPref.available && isAfter && isBefore) {
        return true;
      }
    });
  };

  dateFilter = (incomingMoment: Moment): boolean => {
    if (
      (incomingMoment && incomingMoment.isBefore(moment(), 'day')) ||
      !incomingMoment
    ) {
      return false;
    }

    const advanceNoticeHours = this.getAdvanceNoticeHoursForCalendar();

    if (
      advanceNoticeHours &&
      advanceNoticeHours >= 24 &&
      incomingMoment &&
      incomingMoment.isBefore(moment().add(advanceNoticeHours, 'hours'))
    ) {
      return false;
    }

    if (
      this.vesselPrefs &&
      this.vesselPrefs.advanceNoticeMaxMonths > 0 &&
      incomingMoment &&
      incomingMoment.isAfter(
        moment().add(this.vesselPrefs.advanceNoticeMaxMonths, 'months'),
      )
    ) {
      return false;
    }

    if (
      this.buyflowProductOfferings &&
      this.vesselPrefs &&
      this.buyflowProductOfferings.length > 0 &&
      this.vesselPrefs.customAvailability
    ) {
      let daysArray = ['sun', 'mon', 'tues', 'wed', 'thurs', 'fri', 'sat'];
      let passesProductOfferings = false;

      this.buyflowProductOfferings.forEach((offering) => {
        let requestedDay = daysArray[incomingMoment.day()];
        if (
          offering &&
          offering.active &&
          offering.days[requestedDay] !== false
        ) {
          passesProductOfferings = true;
        }
      });

      if (passesProductOfferings) {
        // let the function continue by doing nothing
      } else {
        return false;
      }
    }

    if (this.unavailables) {
      return !this.unavailables.some((unavailable) =>
        moment(incomingMoment)
          .set('hour', 12)
          .isBetween(unavailable.start, unavailable.end),
      );
    }

    if (incomingMoment && incomingMoment.isSame(moment(), 'day')) {
      return true;
    }
    return true;
  };

  private getAdvanceNoticeHoursForCalendar(): number {
    // if advanceNoticeHours is greater than or equal to a day, we'll want to subtract 24 hours because there will
    //  likely still be selectable times on that day
    return this.vesselPrefs.advanceNoticeMinHours >= 24
      ? this.vesselPrefs.advanceNoticeMinHours - 24
      : this.vesselPrefs.advanceNoticeMinHours;
  }

  updateCalendarSelection(date?): void {
    if (date) {
      this.availableOn = date;
    }
    if (this.charterType === CharterType.DayCharter) {
      sessionStorage.setItem(
        'filterDate',
        this.availableOn?.format(dateSessionStorageFormat),
      );
      this.dateToDisplay = this.availableOn.format('dddd, MMMM Do, YYYY');
      if (this.availableOn?.isValid()) {
        this.getProductsForDay();
      }
    }

    if (this.charterType === CharterType.TermCharter) {
      if (this.availableFrom?.isValid()) {
        sessionStorage.setItem(
          'filterDateRangeStart',
          this.availableFrom?.format(dateSessionStorageFormat),
        );
      }
      if (this.availableTo?.isValid()) {
        sessionStorage.setItem(
          'filterDateRangeEnd',
          this.availableTo?.format(dateSessionStorageFormat),
        );
      }
    }
  }

  onDurationSelect(): void {
    this.setSelectedProduct();
    this.productSelectionChange.next(this.selectedProduct);
    sessionStorage.setItem('requestDuration', this.productDuration.toString());
    this.updateSelectableTimes();
    this.handleRequiredAddOnsQty();
  }

  private setSelectedProduct(): void {
    if (!this.productDuration && this.selectedProduct) {
      this.productDuration = this.selectedProduct.duration;
      this.pricingSettled = true;
      this.productSelectionChange.next(this.selectedProduct);
    } else {
      this.productsOffered.forEach((product) => {
        if (this.productDuration === product.duration) {
          this.selectedProduct = product;
        }
      });
    }
  }

  private updateSelectableTimes() {
    this.selectableTimes = sortTimes(this.selectedProduct?.selectableTimes);
  }

  getProductsForDay() {
    this.pricingSettled = false;

    if (this.availableOn?.isValid()) {
      this.charterBuyflowHelperService
        .getAvailableProductsForDay(true, this.availableOn, this.vessel)
        .subscribe((res) => {
          this.listPrice = res.listPrice;
          this.productsOffered = res.productsOffered;

          this.productsOffered = this.productsOffered?.sort(function (a, b) {
            return a.duration - b.duration;
          });

          this.setSelectedProduct();
          if (this.selectedProduct) {
            this.productDuration = this.selectedProduct.duration;
            this.updateSelectableTimes();
            this.productSelectionChange.next(this.selectedProduct);
          }

          this.dateToDisplay = this.availableOn.format('dddd, MMMM Do, YYYY');

          this.productOfferingDAO
            .findByVesselPreferencesIdForBuyflow(
              this.vessel.id,
              this.vesselPrefs.id,
            )
            .subscribe((res) => {
              res.forEach((product) => {
                // @ts-ignore
                this.buyflowProductOfferings.push(product);
              });
              this.pricingSettled = true;
            });
        });
    }

    this.startMobileDate = false;
  }

  decrementGuestCount() {
    if (this.guestCount > 1) {
      this.guestCount -= 1;
    }
    this.handleRequiredAddOnsQty();
  }

  incrementGuestCount() {
    if (this.guestCount < this.vessel.numOfPassengers) {
      this.guestCount += 1;
    }
    this.handleRequiredAddOnsQty();
  }

  continueButtonDisabled() {
    if (this.charterType === CharterType.DayCharter) {
      return (
        !this.dateToDisplay ||
        !this.availableOn ||
        !this.startTimeText ||
        !this.selectedProduct ||
        !this.productDuration
      );
    }
    if (this.charterType === CharterType.TermCharter) {
      return (
        !this.availableFrom ||
        !this.availableTo ||
        this.termDateRangeUnavailable
      );
    }
  }

  closeDialog(continueToBooking: boolean) {
    this.saveTimeInSessionStorage();
    this.saveGuestCountInSessionStorage();
    this.dialogRef.dismiss({
      continueToBooking,
      charterType: this.charterType,
      availableFrom: this.availableFrom,
      availableTo: this.availableTo,
      termCharterPricing: this.termCharterPricing,
      requiredAddOns: this.requiredAddOns,
    });
  }

  saveTimeInSessionStorage() {
    sessionStorage.setItem('requestStartTime', this.startTimeText);
  }

  saveGuestCountInSessionStorage() {
    sessionStorage.setItem('guestCount', this.guestCount.toString());
  }

  private setProductOffering(
    buyflowCharterInformation: BuyflowCharterInformation,
  ): BuyflowProductOffering {
    const previouslySelectedProduct = JSON.parse(
      sessionStorage.getItem(selectedProductVesselIdWrapper(this.vessel.id)),
    );

    let selectedProduct = this.selectedProduct;
    if (
      previouslySelectedProduct &&
      previouslySelectedProduct.duration &&
      buyflowCharterInformation &&
      buyflowCharterInformation.productsOffered
    ) {
      // if session storage duration matches a product that is offered, keep that as selected product
      const product = buyflowCharterInformation.productsOffered.filter(
        (item) => item.duration === previouslySelectedProduct.duration,
      )[0];
      if (product) {
        selectedProduct = product;
      }
    }
    return selectedProduct;
  }

  private watchForProductChange(): void {
    this.productSelectionChange.subscribe((change) => {
      if (change) {
        if (this.isBrowser) {
          sessionStorage.setItem(
            selectedProductVesselIdWrapper(this.vessel.id),
            JSON.stringify(change),
          );
        }
      }
    });
  }

  setTotalWithPromo(totalWithPromo: number) {
    // did this to suppress `ExpressionChangedAfterItHasBeenCheckedError`
    let that = this;
    setTimeout(function () {
      that.headerPrice = totalWithPromo;
    }, 100);
  }

  onSelectedChange(date: Date): void {
    if (
      moment(date).isAfter(this.availableFrom) &&
      !this.availableTo &&
      this.availableFrom
    ) {
      this.availableTo = moment(date, dateSessionStorageFormat);
      this.selectedDates = new DateRange(this.availableFrom, this.availableTo);
      this.displaySelectedDates = `${this.selectedDates.start?.format(
        'MMM DD',
      )} - ${this.selectedDates.end?.format('MMM DD')}`;
      this.getTermCharterPricing();
    } else {
      this.availableFrom = moment(date, dateSessionStorageFormat);
      this.selectedDates = new DateRange(this.availableFrom, null);
      this.displaySelectedDates = `${this.selectedDates.start?.format(
        'MMM DD',
      )}`;
      this.availableTo = null;
    }
    this.termDayCount = getTermCharterDateCount(
      this.availableFrom?.format('YYYY-MM-DD'),
      this.availableTo?.format('YYYY-MM-DD'),
    );
    this.updateCalendarSelection();
  }

  setCharterType({ tab }) {
    if (tab.textLabel === 'Multi-day') {
      const dateStart = sessionStorage.getItem('filterDateRangeStart');
      this.availableFrom = dateStart ? moment(dateStart) : null;
      const dateEnd = sessionStorage.getItem('filterDateRangeEnd');
      this.availableTo = dateEnd ? moment(dateEnd) : null;

      this.charterType = CharterType.TermCharter;
    } else if (tab.textLabel === 'Day Charter') {
      const date = moment(sessionStorage.getItem('filterDate'));
      this.availableOn = date;

      this.charterType = CharterType.DayCharter;
    }

    this.getTermCharterPricing();
  }

  getTermCharterPricing() {
    this.loadingTermPricing = true;

    this.vesselAvailabilityDAO
      .getTermCharterPricing(
        this.vessel.id,
        this.availableFrom?.format('YYYY-MM-DD'),
        this.availableTo?.format('YYYY-MM-DD'),
      )
      .subscribe((termCharterPricing) => {
        this.termCharterPricing = termCharterPricing;
        this.loadingTermPricing = false;
        this.termDateRangeUnavailable = !Object.keys(
          this.termCharterPricing || {},
        ).length;
      });
  }

  handleRequiredAddOnsQty() {
    if (this.selectedProduct?.requiredAddOns) {
      this.requiredAddOns = [
        ...this.selectedProduct.requiredAddOns.map((addOn) => {
          if (addOn.unitType === RequiredAddOnUnitType.PER_PERSON_ABOVE_LIMIT) {
            return { ...addOn, quantity: this.guestCount - addOn.minQuantity };
          }
          return addOn;
        }),
      ];
    }
  }
}
